import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'project-sprint-details-open',
	template: require('./project.sprint.details.open.html'),
})
export class ProjectSprintDetailsOpenComponent {
	@Input() parentCtrl: any;
	@Output() onUpdate: EventEmitter<any> = new EventEmitter();
}
